import React, { useEffect, useMemo, useRef, useState } from 'react';

import { Form, Field } from 'react-final-form';
import FormStateToRedux from '../../RFF/FormStateToRedux';
import { connect } from 'react-redux';
import Select from 'react-select';

import { inputsSettingsTrue, inputsSettingsFalse } from '../../../global/Styles/inputs';
import { ButtonTable } from '../../../global/Styles/buttons';
import TableManifiesto from './TableManifiesto';

import { ModalTitle } from '../../../global/Styles/titles';
import { PanelVehiculoTarifa } from './ModalSeguimiento/PanelVehiculoTarifa';
import { roundWithDecimals, getFormatedNumberFromInput, removeMoneyFormat } from '../../../../utils/format';

const VehiculoLabel = ({ data }) => {
  const onlyOwnerData = {
    propietario: data.V_TERCERO_PROPIETARIO_NOMBRE,
    tenedor: data.V_TERCERO_TENEDOR_NOMBRE,
    propio: data.V_VEHICULO_PROPIO,
  };

  const vehiculoData = {
    isOurAsset: onlyOwnerData.propio === 1,
    isOurAssetText: onlyOwnerData.propio === 1 ? 'Propio' : 'Ext.',
    propietario: onlyOwnerData.propietario,
    tenedor: onlyOwnerData.tenedor,
    externoText: onlyOwnerData.tenedor ? '(T)' : '(P)',
    externoName: onlyOwnerData.tenedor ? onlyOwnerData.tenedor : onlyOwnerData.propietario,
  };

  return (
    <span className={`${vehiculoData.isOurAsset ? 'text-green-600' : 'text-red-600'} `}>
      {`${vehiculoData.isOurAssetText || '...'} ${(!vehiculoData.isOurAsset && vehiculoData.externoText) || ''} ${
        (!vehiculoData.isOurAsset && vehiculoData.externoName) || ''
      }`}
    </span>
  );
};

const TrailerLabel = ({ data }) => {
  const onlyOwnerData = {
    propietario: data.T_TERCERO_PROPIETARIO_NOMBRE,
    tenedor: data.T_TERCERO_TENEDOR_NOMBRE,
    propio: data.T_VEHICULO_PROPIO,
  };

  const vehiculoData = {
    isOurAsset: onlyOwnerData.propio === 1,
    isOurAssetText: onlyOwnerData.propio === 1 ? 'Propio' : 'Ext.',
    propietario: onlyOwnerData.propietario,
    tenedor: onlyOwnerData.tenedor,
    externoText: onlyOwnerData.tenedor ? '(T)' : '(P)',
    externoName: onlyOwnerData.tenedor ? onlyOwnerData.tenedor : onlyOwnerData.propietario,
  };

  return (
    <span className={`${vehiculoData.isOurAsset ? 'text-green-600' : 'text-red-600'} `}>
      {`${vehiculoData.isOurAssetText || '...'} ${(!vehiculoData.isOurAsset && vehiculoData.externoText) || ''} ${
        (!vehiculoData.isOurAsset && vehiculoData.externoName) || ''
      }`}
    </span>
  );
};

const ConductorLabel = ({ data }) => {
  const employeeData = {
    isEmployee: data.CONDUCTOR_ES_EMPLEADO === 1,
    isEmployeeMsg: data.CONDUCTOR_ES_EMPLEADO === 1 ? 'Empleado' : 'Externo',
  };
  return <span className={`${employeeData.isEmployee ? 'text-green-600' : 'text-red-600'} `}>{`${employeeData.isEmployeeMsg || '...'} `}</span>;
};

const isConductorEmployee = (data) => {
  return data.CONDUCTOR_ES_EMPLEADO === 1;
};
const AparejadorLabel = ({ data }) => {
  const employeeData = {
    isEmployee: data.APAREJADOR_ES_EMPLEADO === 1,
    isEmployeeMsg: data.APAREJADOR_ES_EMPLEADO === 1 ? 'Empleado' : 'Externo',
  };
  return <span className={`${employeeData.isEmployee ? 'text-green-600' : 'text-red-600'} `}>{`${employeeData.isEmployeeMsg || '...'} `}</span>;
};

const isAparejadorEmployee = (data) => {
  return data.APAREJADOR_ES_EMPLEADO === 1;
};

const BeneficiarySelect = ({ input, meta, options, selectedBeneficiary, onSelect, form }) => {
  useEffect(() => {
    const nextValue = selectedBeneficiary?.value || '';
    if (input.value !== nextValue) {
      input.onChange(nextValue);
    }

    if (selectedBeneficiary) {
      form.change('CONDUCTOR_BENEFICIARIO_TIPO', selectedBeneficiary.tipo || '');
      form.change('CONDUCTOR_BENEFICIARIO_ES_TERCERO', selectedBeneficiary.tipo === 'TERCERO' ? 1 : 0);
      form.change('CONDUCTOR_BENEFICIARIO_NOMBRE', selectedBeneficiary.rawName || selectedBeneficiary.label || '');
      form.change('CONDUCTOR_BENEFICIARIO_DOCUMENTO', selectedBeneficiary.documento || '');
      form.change('PROVEEDOR_TERCERO_ID', selectedBeneficiary.tipo === 'TERCERO' ? selectedBeneficiary.value || '' : '');
    } else {
      form.change('CONDUCTOR_BENEFICIARIO_TIPO', '');
      form.change('CONDUCTOR_BENEFICIARIO_ES_TERCERO', 0);
      form.change('CONDUCTOR_BENEFICIARIO_NOMBRE', '');
      form.change('CONDUCTOR_BENEFICIARIO_DOCUMENTO', '');
      form.change('PROVEEDOR_TERCERO_ID', '');
    }
  }, [form, input, selectedBeneficiary]);

  const handleChange = (option) => {
    onSelect(option || null);
    input.onChange(option ? option.value : '');
  };

  return (
    <>
      <Select
        classNamePrefix="react-select"
        placeholder="Seleccione beneficiario"
        options={options}
        value={selectedBeneficiary || null}
        onChange={handleChange}
        onBlur={() => input.onBlur(selectedBeneficiary?.value || '')}
        isClearable={options.length > 0}
        noOptionsMessage={() => 'Sin opciones disponibles'}
      />
      {meta.error && (meta.touched || meta.submitFailed) ? <span className="text-xs text-red-500">{meta.error}</span> : null}
      {selectedBeneficiary ? (
        <p className="mt-1 text-xs text-gray-500">
          Beneficiario seleccionado: {selectedBeneficiary.rawName || selectedBeneficiary.label} ({selectedBeneficiary.tipo})
        </p>
      ) : null}
    </>
  );
};

export const ModalNuevoAnticipo = (props) => {
  const { setIsModalNuevoAnticipoVisible } = props;

  const { createNuevoAnticipo } = props.endPoint;
  const { handleChangeTarifaUnidad, handleAddTarifa } = props.actions;

  const selTipoVehiculo = props.tipoVehiculo.selTipoVehiculo;

  const anticipo_cargo = selTipoVehiculo.anticipo_cargo;

  const hasAparejador = selTipoVehiculo.APAREJADOR_DOC ? true : false;
  const hasTrailer = selTipoVehiculo.TRAILER_PLACA ? true : false;

  const conductorOptionsCatalog = props.data?.conductorOptions || [];

  const beneficiaryOptions = useMemo(() => {
    const options = [];
    const seen = new Set();

    const pushOption = (option) => {
      if (!option || option.value === undefined || option.value === null || option.value === '') return;
      const key = `${option.tipo}-${option.value}`;
      if (seen.has(key)) return;
      seen.add(key);
      options.push(option);
    };

    if (selTipoVehiculo) {
      const conductorId = selTipoVehiculo.CONDUCTOR_TERCERO_ID ?? selTipoVehiculo.CONDUCTOR_DOC ?? selTipoVehiculo.CONDUCTOR_NOMBRE ?? '';
      if (selTipoVehiculo.CONDUCTOR_NOMBRE || conductorId) {
        pushOption({
          value: conductorId,
          label: `${selTipoVehiculo.CONDUCTOR_NOMBRE || 'Conductor'} (Conductor)`,
          rawName: selTipoVehiculo.CONDUCTOR_NOMBRE || '',
          tipo: 'CONDUCTOR',
          isEmployee: selTipoVehiculo.CONDUCTOR_ES_EMPLEADO === 1,
          documento: selTipoVehiculo.CONDUCTOR_DOC || '',
        });
      }

      if (selTipoVehiculo.V_VEHICULO_PROPIO === 0) {
        const tenedorId = selTipoVehiculo.V_TERCERO_TENEDOR_ID ?? selTipoVehiculo.V_TERCERO_TENEDOR_DOC;
        if (tenedorId) {
          pushOption({
            value: tenedorId,
            label: `${selTipoVehiculo.V_TERCERO_TENEDOR_NOMBRE || 'Tenedor'} (Tenedor)`,
            rawName: selTipoVehiculo.V_TERCERO_TENEDOR_NOMBRE || '',
            tipo: 'TENEDOR',
            isEmployee: false,
            documento: selTipoVehiculo.V_TERCERO_TENEDOR_DOC || '',
          });
        }

        const propietarioId = selTipoVehiculo.V_TERCERO_PROPIETARIO_ID ?? selTipoVehiculo.V_TERCERO_PROPIETARIO_DOC;
        if (propietarioId) {
          pushOption({
            value: propietarioId,
            label: `${selTipoVehiculo.V_TERCERO_PROPIETARIO_NOMBRE || 'Propietario'} (Propietario)`,
            rawName: selTipoVehiculo.V_TERCERO_PROPIETARIO_NOMBRE || '',
            tipo: 'PROPIETARIO',
            isEmployee: false,
            documento: selTipoVehiculo.V_TERCERO_PROPIETARIO_DOC || '',
          });
        }
      }
    }

    conductorOptionsCatalog.forEach((option) => {
      if (!option) return;
      pushOption({
        value: option.value,
        label: `${option.label} (Proveedor)`,
        rawName: option.label,
        tipo: 'TERCERO',
        isEmployee: option.isEmployee === 1 || option.isEmployee === true,
        documento: option.documento || '',
      });
    });

    return options;
  }, [conductorOptionsCatalog, selTipoVehiculo]);

  const defaultBeneficiary = useMemo(() => {
    if (!beneficiaryOptions.length) return null;

    if (selTipoVehiculo?.V_VEHICULO_PROPIO === 0) {
      const tenedor = beneficiaryOptions.find((option) => option.tipo === 'TENEDOR');
      if (tenedor) return tenedor;
      const propietario = beneficiaryOptions.find((option) => option.tipo === 'PROPIETARIO');
      if (propietario) return propietario;
    }

    const conductor = beneficiaryOptions.find((option) => option.tipo === 'CONDUCTOR');
    if (conductor) return conductor;

    return beneficiaryOptions[0];
  }, [beneficiaryOptions, selTipoVehiculo?.V_VEHICULO_PROPIO]);

  const [selectedBeneficiary, setSelectedBeneficiary] = useState(defaultBeneficiary);

  const shouldInitializeConductorValueAtZero = useMemo(() => {
    if (!selTipoVehiculo) return false;
    const vehicleIsOwned = selTipoVehiculo.V_VEHICULO_PROPIO === 1;
    const conductorIsEmployee = isConductorEmployee(selTipoVehiculo);
    const beneficiaryIsConductor = defaultBeneficiary?.tipo === 'CONDUCTOR';

    return vehicleIsOwned && conductorIsEmployee && beneficiaryIsConductor;
  }, [defaultBeneficiary?.tipo, selTipoVehiculo?.V_VEHICULO_PROPIO, selTipoVehiculo?.CONDUCTOR_ES_EMPLEADO]);

  const formRef = useRef(null);

  useEffect(() => {
    if (!beneficiaryOptions.length) {
      if (selectedBeneficiary !== null) {
        setSelectedBeneficiary(null);
      }
      return;
    }

    if (selectedBeneficiary) {
      const matched = beneficiaryOptions.find(
        (option) => String(option.value) === String(selectedBeneficiary.value) && option.tipo === selectedBeneficiary.tipo
      );

      if (matched) {
        if (matched !== selectedBeneficiary) {
          setSelectedBeneficiary(matched);
        }
        return;
      }
    }

    const fallback = defaultBeneficiary || beneficiaryOptions[0];
    if (fallback !== selectedBeneficiary) {
      setSelectedBeneficiary(fallback);
    }
  }, [beneficiaryOptions, defaultBeneficiary, selectedBeneficiary]);

  const externalBeneficiaryMessage = useMemo(() => {
    if (selTipoVehiculo?.V_VEHICULO_PROPIO !== 0) {
      return '';
    }

    if (!selectedBeneficiary) {
      return 'Vehículo externo: el anticipo se dirige al tenedor y, en su ausencia, al propietario.';
    }

    if (selectedBeneficiary.tipo === 'TENEDOR') {
      return `Vehículo externo: el anticipo se dirige al tenedor del vehículo (${selectedBeneficiary.rawName || selectedBeneficiary.label}).`;
    }

    if (selectedBeneficiary.tipo === 'PROPIETARIO') {
      return `Vehículo externo sin tenedor: el anticipo se dirige al propietario (${selectedBeneficiary.rawName || selectedBeneficiary.label}).`;
    }

    if (selectedBeneficiary.tipo === 'TERCERO') {
      return `Vehículo externo: el anticipo se asignará al proveedor externo seleccionado (${
        selectedBeneficiary.rawName || selectedBeneficiary.label
      }); no se abonará al conductor ni al tenedor.`;
    }

    return 'Vehículo externo: recuerde que por defecto el anticipo corresponde al tenedor del vehículo.';
  }, [selectedBeneficiary, selTipoVehiculo?.V_VEHICULO_PROPIO]);

  const [percentages, setPercentages] = useState({
    CONDUCTOR: { remaining: 0, advance: 0 },
    APAREJADOR: { remaining: 0, advance: 0 },
  });

  useEffect(() => {
    setPercentages({
      CONDUCTOR: {
        remaining: Number(selTipoVehiculo?.SOLICITUD_VEHICULO_P1) || 0,
        advance: Number(selTipoVehiculo?.SOLICITUD_VEHICULO_P2) || 0,
      },
      APAREJADOR: {
        remaining: Number(selTipoVehiculo?.SOLICITUD_VEHICULO_P3) || 0,
        advance: Number(selTipoVehiculo?.SOLICITUD_VEHICULO_P4) || 0,
      },
    });
  }, [
    selTipoVehiculo?.SOLICITUD_VEHICULO_P1,
    selTipoVehiculo?.SOLICITUD_VEHICULO_P2,
    selTipoVehiculo?.SOLICITUD_VEHICULO_P3,
    selTipoVehiculo?.SOLICITUD_VEHICULO_P4,
  ]);

  useEffect(() => {
    if (!formRef.current) return;

    const vehicleIsOwned = selTipoVehiculo?.V_VEHICULO_PROPIO === 1;
    const conductorIsEmployee = isConductorEmployee(selTipoVehiculo);
    const beneficiaryIsConductor = selectedBeneficiary?.tipo === 'CONDUCTOR';

    const shouldForceZero = vehicleIsOwned && conductorIsEmployee && beneficiaryIsConductor;

    if (!shouldForceZero) {
      return;
    }

    const { values } = formRef.current.getState();
    const currentValue = Number(removeMoneyFormat(`${values?.CONDUCTOR_VALOR || 0}`));

    if (currentValue !== 0) {
      const formattedZero = getFormatedNumberFromInput('0');
      formRef.current.change('CONDUCTOR_VALOR', formattedZero);

      const total = Number(selTipoVehiculo?.SOLICITUD_DETALLE_TOTAL || 0);
      updateRemainingPercentage('CONDUCTOR', total, 0);
    }
  }, [selectedBeneficiary?.tipo, selTipoVehiculo?.V_VEHICULO_PROPIO, selTipoVehiculo?.CONDUCTOR_ES_EMPLEADO, selTipoVehiculo?.SOLICITUD_DETALLE_TOTAL]);

  const updateRemainingPercentage = (key, total, value) => {
    const percent = total === 0 ? 0 : 100 - (value * 100) / total;
    setPercentages((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        remaining: roundWithDecimals(percent || 0, 2),
      },
    }));
  };

  const updateAdvancePercentage = (key, total, value) => {
    const percent = total === 0 ? 0 : (value * 100) / total;
    setPercentages((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        advance: roundWithDecimals(percent || 0, 2),
      },
    }));
  };

  const setSOLICITUD_VEHICULO_TIPO = (args, state, { setIn, changeValue }) => {
    const field = state.fields['SOLICITUD_VEHICULO_TIPO'];
    field.change(args[0].value);
    state.formState.submitFailed = true;
  };

  const setVEHICULO_ID = (args, state, { setIn, changeValue }) => {
    const field = state.fields['VEHICULO_ID'];
    field.change(args[0].value);
    state.formState.submitFailed = true;
  };

  const setTRAILER_ID = (args, state, { setIn, changeValue }) => {
    const field = state.fields['TRAILER_ID'];
    field.change(args[0].value);
    state.formState.submitFailed = true;
  };

  const setCONDUCTOR_TERCERO_ID = (args, state, { setIn, changeValue }) => {
    const field = state.fields['CONDUCTOR_TERCERO_ID'];
    field.change(args[0].value);
    state.formState.submitFailed = true;
  };
  const setPROVEEDOR_TERCERO_ID = (args, state, { setIn, changeValue }) => {
    const field = state.fields['PROVEEDOR_TERCERO_ID'];
    field.change(args[0].value);
    state.formState.submitFailed = true;
  };
  const setAPAREJADOR_TERCERO_ID = (args, state, { setIn, changeValue }) => {
    const field = state.fields['APAREJADOR_TERCERO_ID'];
    field.change(args[0].value);
    state.formState.submitFailed = true;
  };

  const setTARIFA_ID = (args, state, { setIn, changeValue }) => {
    const field = state.fields['TARIFA_ID'];
    field.change(args[0].value);

    state.formState.submitFailed = true;
  };

  const setCONDUCTOR_VALOR = (args, state, { setIn, changeValue }) => {
    const field = state.fields['CONDUCTOR_VALOR'];

    const formattedValue = getFormatedNumberFromInput(args[0].target.value);

    const value = removeMoneyFormat(formattedValue);

    field.change(formattedValue);

    const total = Number(props.tipoVehiculo.selTipoVehiculo.SOLICITUD_DETALLE_TOTAL);

    updateRemainingPercentage('CONDUCTOR', total, value);

    state.formState.submitFailed = true;
  };

  const setAPAREJADOR_VALOR = (args, state, { setIn, changeValue }) => {
    const field = state.fields['APAREJADOR_VALOR'];

    const formattedValue = getFormatedNumberFromInput(args[0].target.value);
    const value = removeMoneyFormat(formattedValue);

    field.change(formattedValue);

    const total = Number(props.tipoVehiculo.selTipoVehiculo.SOLICITUD_DETALLE_TOTAL);

    updateRemainingPercentage('APAREJADOR', total, value);

    state.formState.submitFailed = true;
  };

  const setCONDUCTOR_ANTICIPO = (args, state, { setIn, changeValue }) => {
    const field = state.fields['CONDUCTOR_ANTICIPO'];
    const fieldTotal = state.fields['CONDUCTOR_VALOR'];

    const formattedValue = getFormatedNumberFromInput(args[0].target.value);
    const value = removeMoneyFormat(formattedValue);

    field.change(formattedValue);

    const total = Number(removeMoneyFormat(fieldTotal.lastFieldState.value) || props.tipoVehiculo.selTipoVehiculo.SOLICITUD_DETALLE_TOTAL);

    updateAdvancePercentage('CONDUCTOR', total, value);

    state.formState.submitFailed = true;
  };

  const setAPAREJADOR_ANTICIPO = (args, state, { setIn, changeValue }) => {
    const field = state.fields['APAREJADOR_ANTICIPO'];
    const fieldTotal = state.fields['APAREJADOR_VALOR'];

    const formattedValue = getFormatedNumberFromInput(args[0].target.value);
    const value = removeMoneyFormat(formattedValue);

    field.change(formattedValue);

    const total = Number(removeMoneyFormat(fieldTotal.lastFieldState.value) || props.tipoVehiculo.selTipoVehiculo.SOLICITUD_DETALLE_TOTAL);

    updateAdvancePercentage('APAREJADOR', total, value);

    state.formState.submitFailed = true;
  };

  const setTARIFA_UNIDAD = (args, state, { setIn, changeValue }) => {
    const field = state.fields['TARIFA_UNIDAD'];
    field.change(args[0].value);
    state.formState.submitFailed = true;

    handleChangeTarifaUnidad(props.tipoVehiculo.selTipoVehiculo.VEHICULO_TIPO_ID, args[0].value);
  };

  const isCurrentBeneficiaryEmployee = () => {
    if (!selectedBeneficiary) return false;
    if (selectedBeneficiary.tipo === 'CONDUCTOR') {
      return isConductorEmployee(selTipoVehiculo);
    }
    return !!selectedBeneficiary.isEmployee;
  };

  const validate = (values) => {
    const errors = {};
    const sanitizeAmount = (value) => Number(removeMoneyFormat(`${value || 0}`));

    const conductorValue = sanitizeAmount(values['CONDUCTOR_VALOR']);
    const conductorAdvance = sanitizeAmount(values['CONDUCTOR_ANTICIPO']);
    const aparejadorValue = sanitizeAmount(values['APAREJADOR_VALOR']);
    const aparejadorAdvance = sanitizeAmount(values['APAREJADOR_ANTICIPO']);

    const conductorEmployee = isCurrentBeneficiaryEmployee();
    const aparejadorEmployee = isAparejadorEmployee(selTipoVehiculo);

    if (beneficiaryOptions.length > 0 && !values['CONDUCTOR_BENEFICIARIO_ID']) {
      errors['CONDUCTOR_BENEFICIARIO_ID'] = 'Seleccione un beneficiario';
    }

    if (conductorEmployee) {
      if (conductorValue !== 0) {
        errors['CONDUCTOR_VALOR'] = '*';
      }
    } else if (conductorValue <= 0) {
      errors['CONDUCTOR_VALOR'] = '*';
    }

    if (hasAparejador) {
      if (aparejadorEmployee) {
        if (aparejadorValue !== 0) {
          errors['APAREJADOR_VALOR'] = '*';
        }
      } else if (aparejadorValue <= 0) {
        errors['APAREJADOR_VALOR'] = '*';
      }
    }

    if (hasAparejador) {
      if (conductorAdvance + aparejadorAdvance === 0) {
        errors['CONDUCTOR_ANTICIPO'] = 'Al menos un anticipo es requerido';
        errors['APAREJADOR_ANTICIPO'] = 'Al menos un anticipo es requerido';
      }
      return errors;
    }

    if (conductorAdvance === 0) {
      errors['CONDUCTOR_ANTICIPO'] = 'Al menos un anticipo es requerido';
    }

    return errors;
  };

  const handleFormSubmit = async (form) => {
    const withAllValues = {
      ...form,
      SOLICITUD_VEHICULO_P1: percentages.CONDUCTOR.remaining,
      SOLICITUD_VEHICULO_P2: percentages.CONDUCTOR.advance,
      SOLICITUD_VEHICULO_P3: percentages.APAREJADOR.remaining,
      SOLICITUD_VEHICULO_P4: percentages.APAREJADOR.advance,
      CONDUCTOR_BENEFICIARIO_ID: form.CONDUCTOR_BENEFICIARIO_ID || selectedBeneficiary?.value || '',
      CONDUCTOR_BENEFICIARIO_TIPO: form.CONDUCTOR_BENEFICIARIO_TIPO || selectedBeneficiary?.tipo || '',
      CONDUCTOR_BENEFICIARIO_ES_TERCERO:
        form.CONDUCTOR_BENEFICIARIO_ES_TERCERO !== undefined ? Number(form.CONDUCTOR_BENEFICIARIO_ES_TERCERO) : selectedBeneficiary?.tipo === 'TERCERO' ? 1 : 0,
      CONDUCTOR_BENEFICIARIO_NOMBRE: form.CONDUCTOR_BENEFICIARIO_NOMBRE || selectedBeneficiary?.rawName || selectedBeneficiary?.label || '',
      CONDUCTOR_BENEFICIARIO_DOCUMENTO: form.CONDUCTOR_BENEFICIARIO_DOCUMENTO || selectedBeneficiary?.documento || '',
      PROVEEDOR_TERCERO_ID:
        form.PROVEEDOR_TERCERO_ID !== undefined ? form.PROVEEDOR_TERCERO_ID : selectedBeneficiary?.tipo === 'TERCERO' ? selectedBeneficiary?.value || '' : '',
    };

    withAllValues['CONDUCTOR_VALOR'] = removeMoneyFormat('' + withAllValues['CONDUCTOR_VALOR']);
    withAllValues['APAREJADOR_VALOR'] = removeMoneyFormat('' + withAllValues['APAREJADOR_VALOR']);
    withAllValues['CONDUCTOR_ANTICIPO'] = removeMoneyFormat('' + withAllValues['CONDUCTOR_ANTICIPO']);
    withAllValues['APAREJADOR_ANTICIPO'] = removeMoneyFormat('' + withAllValues['APAREJADOR_ANTICIPO']);
    createNuevoAnticipo(withAllValues);
  };

  return (
    <div
      className="min-w-screen animated fadeIn faster outline-none  focus:outline-none  fixed inset-0 left-0 top-0 z-50 flex h-screen items-center justify-center overflow-y-scroll bg-cover bg-center bg-no-repeat"
      id="modal-id">
      <div className="fixed inset-0 z-0 bg-black opacity-50"></div>
      <div className="relative mx-auto my-auto w-full max-w-6xl rounded-xl bg-white p-5  shadow-lg ">
        <ModalTitle>NUEVA SOLICITUD DE ANTICIPO</ModalTitle>
        <div className="flex-auto justify-center p-1 text-left">
          <TableManifiesto />
        </div>

        <div className="px-5">
          <hr className="mt-1" />
          <PanelVehiculoTarifa
            isReadOnly={true}
            handleAddTarifa={handleAddTarifa}
            handleChangeTarifaUnidad={handleChangeTarifaUnidad}
            data={{ selSolicitudVehiculoTipo: props.tipoVehiculo.selTipoVehiculo }}
          />
        </div>

        <Form
          onSubmit={handleFormSubmit}
          validate={validate}
          mutators={{
            setSOLICITUD_VEHICULO_TIPO,
            setVEHICULO_ID,
            setTRAILER_ID,
            setCONDUCTOR_TERCERO_ID,
            setTARIFA_UNIDAD,
            setTARIFA_ID,
            setPROVEEDOR_TERCERO_ID,
            setAPAREJADOR_TERCERO_ID,
            setCONDUCTOR_VALOR,
            setAPAREJADOR_VALOR,
            setCONDUCTOR_ANTICIPO,
            setAPAREJADOR_ANTICIPO,
          }}
          initialValues={{
            SOLICITUD_ID: props.Solicitud.selSolicitud.SOLICITUD_ID,
            SOLICITUD_VEHICULO_TIPO_ID: props.tipoVehiculo.selTipoVehiculo.SOLICITUD_VEHICULO_TIPO_ID,
            CONDUCTOR_VALOR: shouldInitializeConductorValueAtZero ? getFormatedNumberFromInput('0') : selTipoVehiculo.CONDUCTOR_VALOR,
            CONDUCTOR_ANTICIPO: 0,
            CONDUCTOR_BENEFICIARIO_ID: selectedBeneficiary?.value || '',
            CONDUCTOR_BENEFICIARIO_TIPO: selectedBeneficiary?.tipo || '',
            CONDUCTOR_BENEFICIARIO_ES_TERCERO: selectedBeneficiary?.tipo === 'TERCERO' ? 1 : 0,
            CONDUCTOR_BENEFICIARIO_NOMBRE: selectedBeneficiary?.rawName || selectedBeneficiary?.label || selTipoVehiculo.CONDUCTOR_NOMBRE || '',
            CONDUCTOR_BENEFICIARIO_DOCUMENTO: selectedBeneficiary?.documento || '',
            PROVEEDOR_TERCERO_ID: selectedBeneficiary?.tipo === 'TERCERO' ? selectedBeneficiary?.value || '' : '',
            SOLICITUD_PESO: selTipoVehiculo.SOLICITUD_PESO,
            PROVEEDOR_VALOR: selTipoVehiculo.PROVEEDOR_VALOR,
            PROVEEDOR_ANTICIPO: selTipoVehiculo.PROVEEDOR_ANTICIPO,
            APAREJADOR_VALOR: selTipoVehiculo.APAREJADOR_VALOR,
            APAREJADOR_ANTICIPO: 0,
            VEHICULO_PLACA: selTipoVehiculo.VEHICULO_PLACA,
            TRAILER_PLACA: selTipoVehiculo.TRAILER_PLACA,
            CONDUCTOR_NOMBRE: selTipoVehiculo.CONDUCTOR_NOMBRE,
            APAREJADOR_NOMBRE: selTipoVehiculo.APAREJADOR_NOMBRE,
            ANTICIPO_CARGO: anticipo_cargo,
            TERCERO_AUDITORIA: props.data.auth.data.selCliente.TERCERO_ID,
            CONDUCTOR_VALOR_NOTA: '',
            APAREJADOR_VALOR_NOTA: '',
          }}
          subscription={{ submitting: true, pristine: true }}>
          {({ handleSubmit, form, submitting, pristine }) => {
            formRef.current = form;

            return (
              <form onSubmit={handleSubmit}>
                <FormStateToRedux form="frmReporteAnticipos" />
                <div className="">
                  <div className="flex-auto justify-center p-5 text-left">
                    {/* <h2 className="text-xl py-4 ">Reporte</h2> */}
                    <div className="flex space-x-4">
                      <div className="mt-1 w-1/3">
                        <Field name="VEHICULO_PLACA">
                          {({ input, meta }) => (
                            <>
                              <p className="text-sm text-gray-800">
                                Vehículo <VehiculoLabel data={selTipoVehiculo} />
                              </p>
                              <input
                                {...input}
                                readOnly
                                type="text"
                                placeholder="Peso"
                                className={meta.error && meta.touched ? `${inputsSettingsFalse}` : `${inputsSettingsTrue}`}
                              />
                            </>
                          )}
                        </Field>
                      </div>
                      <div className="mt-1 w-1/3">
                        {hasTrailer && (
                          <Field name="TRAILER_PLACA">
                            {({ input, meta }) => (
                              <>
                                <p className="text-sm text-gray-800">
                                  Trailer <TrailerLabel data={selTipoVehiculo} />
                                </p>
                                <input
                                  {...input}
                                  type="text"
                                  readOnly
                                  placeholder="Peso"
                                  className={meta.error && meta.touched ? `${inputsSettingsFalse}` : `${inputsSettingsTrue}`}
                                />
                              </>
                            )}
                          </Field>
                        )}
                      </div>
                      <div className="mt-1 w-1/3">
                        <Field name="SOLICITUD_PESO">
                          {({ input, meta }) => (
                            <>
                              <p className="text-sm text-gray-800">Peso</p>
                              <input
                                {...input}
                                type="text"
                                readOnly
                                placeholder="Peso"
                                className={meta.error && meta.touched ? `${inputsSettingsFalse}` : `${inputsSettingsTrue}`}
                              />
                            </>
                          )}
                        </Field>
                      </div>
                    </div>

                    <div className="flex space-x-4">
                      <div className="mt-1 w-1/3">
                        <Field name="CONDUCTOR_BENEFICIARIO_ID">
                          {({ input, meta }) => (
                            <>
                              <p className="text-sm text-gray-800">Beneficiario del anticipo</p>
                              <BeneficiarySelect
                                input={input}
                                meta={meta}
                                options={beneficiaryOptions}
                                selectedBeneficiary={selectedBeneficiary}
                                onSelect={setSelectedBeneficiary}
                                form={form}
                              />
                              <p className="mt-1 text-xs text-gray-500">
                                Conductor: {selTipoVehiculo.CONDUCTOR_NOMBRE || 'Sin conductor'} <ConductorLabel data={selTipoVehiculo} />
                              </p>
                              {externalBeneficiaryMessage ? <p className="text-orange-500 text-xs">{externalBeneficiaryMessage}</p> : null}
                            </>
                          )}
                        </Field>
                        <Field name="CONDUCTOR_BENEFICIARIO_TIPO">
                          {({ input }) => (
                            <input
                              {...input}
                              type="hidden"
                            />
                          )}
                        </Field>
                        <Field name="CONDUCTOR_BENEFICIARIO_ES_TERCERO">
                          {({ input }) => (
                            <input
                              {...input}
                              type="hidden"
                            />
                          )}
                        </Field>
                        <Field name="CONDUCTOR_BENEFICIARIO_NOMBRE">
                          {({ input }) => (
                            <input
                              {...input}
                              type="hidden"
                            />
                          )}
                        </Field>
                        <Field name="CONDUCTOR_BENEFICIARIO_DOCUMENTO">
                          {({ input }) => (
                            <input
                              {...input}
                              type="hidden"
                            />
                          )}
                        </Field>
                        <Field name="PROVEEDOR_TERCERO_ID">
                          {({ input }) => (
                            <input
                              {...input}
                              type="hidden"
                            />
                          )}
                        </Field>
                        <Field name="CONDUCTOR_NOMBRE">
                          {({ input }) => (
                            <input
                              {...input}
                              type="hidden"
                            />
                          )}
                        </Field>
                      </div>
                      <div className="mt-1 w-1/3">
                        <Field name="CONDUCTOR_VALOR">
                          {({ input, meta }) => (
                            <>
                              <p className="text-sm text-gray-800">
                                Costo Servicio <span className=" text-green-500"> {percentages.CONDUCTOR.remaining}%</span>
                              </p>
                              <input
                                {...input}
                                type="text"
                                placeholder="Costo Servicio"
                                readOnly={isCurrentBeneficiaryEmployee()}
                                onChange={form.mutators.setCONDUCTOR_VALOR}
                                className={meta.error && meta.touched ? `${inputsSettingsFalse}` : `${inputsSettingsTrue}`}
                              />
                            </>
                          )}
                        </Field>
                      </div>
                      <div className="mt-1 w-1/3">
                        <Field name="CONDUCTOR_ANTICIPO">
                          {({ input, meta }) => (
                            <>
                              <p className="text-sm text-gray-800">
                                Anticipo <span className=" text-green-500"> {percentages.CONDUCTOR.advance}% </span>
                              </p>
                              <input
                                {...input}
                                type="text"
                                placeholder="Anticipo"
                                onChange={form.mutators.setCONDUCTOR_ANTICIPO}
                                className={meta.error && meta.touched ? `${inputsSettingsFalse}` : `${inputsSettingsTrue}`}
                              />
                            </>
                          )}
                        </Field>
                      </div>
                    </div>
                    <div className="flex space-x-4">
                      <div className="mt-1 w-1/3"></div>
                      <div className="mt-1 w-2/3">
                        <Field name="CONDUCTOR_VALOR_NOTA">
                          {({ input, meta }) => (
                            <>
                              <p className="text-sm text-gray-800">Nota</p>
                              <input
                                {...input}
                                type="text"
                                placeholder="Nota"
                                className={meta.error && meta.touched ? `${inputsSettingsFalse}` : `${inputsSettingsTrue}`}
                              />
                            </>
                          )}
                        </Field>
                      </div>
                    </div>
                    {hasAparejador && (
                      <>
                        <div className="flex space-x-4">
                          <div className="mt-1 w-1/3">
                            <Field name="APAREJADOR_NOMBRE">
                              {({ input, meta }) => (
                                <>
                                  <p className="text-sm text-gray-800">
                                    Aparejador / Auxiliar <AparejadorLabel data={selTipoVehiculo} />
                                  </p>
                                  <input
                                    {...input}
                                    type="text"
                                    readOnly
                                    className={meta.error && meta.touched ? `${inputsSettingsFalse}` : `${inputsSettingsTrue}`}
                                  />
                                </>
                              )}
                            </Field>
                          </div>
                          <div className="mt-1 w-1/3">
                            <Field name="APAREJADOR_VALOR">
                              {({ input, meta }) => (
                                <>
                                  <p className="text-sm text-gray-800">
                                    Costo Servicio <span className=" text-green-500">{percentages.APAREJADOR.remaining}%</span>
                                  </p>
                                  <input
                                    {...input}
                                    type="text"
                                    readOnly={isAparejadorEmployee(selTipoVehiculo)}
                                    placeholder="Costo Servicio"
                                    onChange={form.mutators.setAPAREJADOR_VALOR}
                                    className={meta.error && meta.touched ? `${inputsSettingsFalse}` : `${inputsSettingsTrue}`}
                                  />
                                </>
                              )}
                            </Field>
                          </div>
                          <div className="mt-1 w-1/3">
                            <Field name="APAREJADOR_ANTICIPO">
                              {({ input, meta }) => (
                                <>
                                  <p className="text-sm text-gray-800">
                                    Anticipo <span className=" text-green-500">{percentages.APAREJADOR.advance} %</span>
                                  </p>
                                  <input
                                    {...input}
                                    type="text"
                                    placeholder="Anticipo"
                                    onChange={form.mutators.setAPAREJADOR_ANTICIPO}
                                    className={meta.error && meta.touched ? `${inputsSettingsFalse}` : `${inputsSettingsTrue}`}
                                  />
                                </>
                              )}
                            </Field>
                          </div>
                        </div>
                        <div className="flex space-x-4">
                          <div className="mt-1 w-1/3"></div>
                          <div className="mt-1 w-2/3">
                            <Field name="APAREJADOR_VALOR_NOTA">
                              {({ input, meta }) => (
                                <>
                                  <p className="text-sm text-gray-800">Nota</p>
                                  <input
                                    {...input}
                                    type="text"
                                    placeholder="Nota"
                                    className={meta.error && meta.touched ? `${inputsSettingsFalse}` : `${inputsSettingsTrue}`}
                                  />
                                </>
                              )}
                            </Field>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="md:block mx-16 mt-2 space-x-4 text-center">
                    <ButtonTable onClick={() => setIsModalNuevoAnticipoVisible(false)}>Cancelar</ButtonTable>
                    {submitting ? (
                      <ButtonTable
                        type="button"
                        disabled>
                        Enviando...
                      </ButtonTable>
                    ) : (
                      <ButtonTable
                        type="submit"
                        disabled={submitting || pristine}>
                        Generar
                      </ButtonTable>
                    )}
                  </div>
                </div>
              </form>
            );
          }}
        </Form>
      </div>
    </div>
  );
};

const mapStateToProps = function (state) {
  return {
    roles: state.roles,
    tipoVehiculo: state.tipoVehiculo,
    frm: state.finalForm.frmReporte,
    Solicitud: state.Solicitud,
  };
};

//export default Projects;
export default connect(mapStateToProps)(ModalNuevoAnticipo);
